import { IS_SERVER } from 'config';
import { captureErrorInSentry } from 'lib/errors';

const SUPPORTS_SESSION_STORAGE = !IS_SERVER && !!window.sessionStorage?.getItem;

const safe = (cb) => (...args) => {
  try {
    if (SUPPORTS_SESSION_STORAGE) return cb(...args);
  } catch (error) {
    captureErrorInSentry(error);
  }
};

const unsafeSet = (key, value) => {
  window.sessionStorage.setItem(key, JSON.stringify(value));
};

const unsafeGet = (key) => {
  try {
    return JSON.parse(window.sessionStorage.getItem(key)) || {};
  } catch (error) {
    captureErrorInSentry(error);
    return {};
  }
};

const unsafeUpdate = (key, updates) => {
  unsafeSet(key, { ...unsafeGet(key), ...updates });
};

export const get = safe(unsafeGet);

export const set = safe(unsafeSet);

export const update = safe(unsafeUpdate);
